import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TaskFormComponent } from './components/task/task-form/task-form.component';
// import {TimelineComponent} from '../shared/timeline/timeline.component';
// import { TaskPageComponent } from './components/task-page/task-page.component';
// import {SuperTaskSummaryComponent} from '../../modules/superTask/components/superTask-summary/superTask-summary.component';
// import { PetitionAuditLogComponent } from './components/task/petition-audit-log/petition-audit-log.component';
// import { TaskIdResolver } from '../utility/TaskIdResolver';
import { TaskDetailsResolver } from '../utility/TaskDetailsResolver';
import { CreateTaskComponent } from '../../modules/superTask/components/create-task/create-task.component';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import {PetitionerInvoiceViewComponent} from './components/petitioner-invoice-view/petitioner-invoice-view.component';
import { UserPageComponent } from '../user/components/user-page/user-page.component';
import { CreateClientComponent } from '../clients/create-client/create-client.component';

const routes: Routes = [
  {
    path: 'superTask',
    loadChildren: () => import('../superTask/superTask.module').then((mod) => mod.SuperTaskModule),
  },  {
    path: 'invoice-received',
    component: PetitionerInvoiceViewComponent
  },
  {
    path: 'edit-client/:id',
    component: CreateClientComponent,
    canDeactivate: [DirtyFormGuard]
  },
   {
    path: 'newuser',
    pathMatch: 'full',
    component: UserPageComponent,
    canDeactivate: [DirtyFormGuard]
   },
  // {
  //   path: 'task-details/:id',
  //   component: SuperTaskSummaryComponent,
  //   resolve: { taskId: TaskIdResolver },
  //   children: [

  //     {
  //       path: 'task',
  //       component: TaskFormComponent,
  //       canDeactivate: [DirtyFormGuard],
  //       resolve: { taskDetails: TaskDetailsResolver },
  //     },
  //     {
  //       path: 'activity-log',
  //       component: PetitionAuditLogComponent,
  //       canDeactivate: [DirtyFormGuard],
  //       resolve: { taskDetails: TaskDetailsResolver }
  //     },
  //     {
  //       path: 'manage-petition',
  //       resolve: { taskDetails: TaskDetailsResolver },
  //       loadChildren: () => import('./components/task/task-manage-petition/task-manage-petition.module')
  //         .then(m => m.TaskManagePetitionModule)
  //     },
  //     {
  //       path: 'update-employment',
  //       loadChildren: () => import('./../update-employment/update-employment.module')
  //         .then(m => m.UpdateEmploymentModule)
  //     },
  //     {
  //       path: 'builder',
  //       resolve: { taskDetails: TaskDetailsResolver },
  //       loadChildren: () => import('../petition-builder/petition-builder.module').then((mod) => mod.PetitionBuilderModule),
  //     },

  //     {
  //       path: '',
  //       pathMatch: 'full',
  //       redirectTo: 'task'
  //     }
  //   ]
  // },
  {
    // path: 'new',
    // component: CreateTaskComponent,
   // resolve: { taskDetails: TaskIdResolver },
    // children: [
    //   {
    //     path: 'task',
    //     component: TaskFormComponent,
    //     canDeactivate: [DirtyFormGuard],
    //     resolve: { taskDetails: TaskDetailsResolver }
    //   },
    //   {
    //     path: '',
    //     pathMatch: 'full',
    //     redirectTo: 'task'
    //   }
    // ]
  },
  {
    // path: 'rfe',
    // loadChildren: () => import('../rfe-builder/rfe-builder.module').then((mod) => mod.RfeBuilderModule),

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class DashboardRoutingModule { }

